import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaCreditCard,
  FaWallet,
  FaExchangeAlt,

  FaInfoCircle,
  FaGift,
  FaHandsHelping,
} from "react-icons/fa";

import { db } from "../firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";

import TopBar from "./TopBar";
import MatchList from "./MatchList";
import BottomTabs from "./BottomTabs";

import "./MyPage.css";

const MyPage = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  const username =
    localStorage.getItem("username") ||
    JSON.parse(localStorage.getItem("user"))?.username;

  useEffect(() => {
    if (!username) return;

    const q = query(collection(db, "users"), where("username", "==", username));
    const unsub = onSnapshot(q, (snapshot) => {
      if (!snapshot.empty) setUserData(snapshot.docs[0].data());
    });

    return () => unsub();
  }, [username]);

  const menuItems = [
    { label: "Deposit", path: "/deposit", icon: <FaWallet /> },
    { label: "AddAddress", path: "/usdt-management", icon: <FaCreditCard /> },
    { label: "Wekanumber", path: "/add-card", icon: <FaCreditCard /> },

    { label: "Amana Mpya", path: "/newdeposit", icon: <FaExchangeAlt /> },
    { label: "Award", path: "/award", icon: <FaGift /> },
    { label: "Refunds", path: "/userrefunds", icon: <FaHandsHelping /> },
    { label: "MemberMpya", path: "/newregister", icon: <FaInfoCircle /> },
  ];

  return (
    <div className="mp-page">

      <TopBar />

      <div className="mp-container">

        <div className="mp-balance-row">
          <button className="mp-btn-deposit" onClick={() => navigate("/records")}>
            REKODI
          </button>
        </div>

        {/* GRID */}
        <div className="mp-grid">
          {menuItems.map((item, i) => (
            <div className="mp-grid-card" key={i} onClick={() => navigate(item.path)}>
              <div className="mp-grid-icon">{item.icon}</div>
              <div className="mp-grid-label">{item.label}</div>
            </div>
          ))}
        </div>

        {/* PROMO */}
        <div className="mp-promo-row">
          <div className="mp-promo-left" />
          <div className="mp-promo-right">
            <div className="mp-promo-card">
              Furahia Antbet Na Sambaza Link Pokea Mamilion Ya Bonus!
            </div>
          </div>
        </div>

        {/* MARKET = MATCH LIST */}
        <div className="mp-market-header">
          <span>Market</span>
          <div className="mp-market-actions">
            <button className="market-btn">Hot ▾</button>
            <button className="market-btn">More</button>
          </div>
        </div>

        <MatchList />

      </div>

      <BottomTabs active="Home" onTab={(p) => navigate(p)} />

    </div>
  );
};

export default MyPage;